
/* Hide single-value "Select Your Metal" variant options — The Littl */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-form__input').forEach(function(el) {
    var legend = el.querySelector('legend');
    if (!legend) return;
    var text = legend.textContent.toLowerCase().trim();
    if (text.indexOf('metal') === -1) return;
    var inputs = el.querySelectorAll('input[type="radio"], option');
    if (inputs.length <= 1) {
      el.style.display = 'none';
    }
  });
});
